// extracted by mini-css-extract-plugin
module.exports = {"form":"_5D1aG-nX","title":"_5D1IAUoi"};